import { fetchApi } from '@/config/axiosSetting';
import { GetCategoriesListQueryResponseType } from './getCategoriesListQuery.type';

export const getCategoriesListFunction =
  (): Promise<GetCategoriesListQueryResponseType> => {
    return fetchApi.get('/education/categories/');
  };
